// extracted by mini-css-extract-plugin
module.exports = {"themeRoot":"DigitalWizardPageWithTitleTemplate_themeRoot__34iP-","wizardContainer":"DigitalWizardPageWithTitleTemplate_wizardContainer__LCeny"};